/* eslint-disable no-console */
import { register } from 'register-service-worker';
import { POSITION, useToast } from 'vue-toastification';
import Toast from '@/components/UpdateNotification.vue';
import Offline from '@/components/OfflineNotification.vue';
const toast = useToast();
const showOfflineNotification = () => {
    toast.error({
        component: Offline
    }, { position: POSITION.TOP_RIGHT, id: 'offline' });
};
const showOnlineNotification = () => {
    toast.success('You are back online', {
        position: POSITION.TOP_RIGHT,
        timeout: false,
        showCloseButtonOnHover: true,
        closeButton: 'button',
        id: 'online'
    });
};
const enableSwDev = process.env.VUE_APP_ENABLE_SW_DEV === 'true';
if (process.env.NODE_ENV === 'production' ||
    (process.env.NODE_ENV === 'development' && enableSwDev)) {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log('App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB');
        },
        registered() {
            console.log('Service worker has been registered.');
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound() {
            console.log('New content is downloading.');
        },
        updated() {
            console.log('New content is available; please refresh.');
            if (window.location.href.includes('/hrgs')) {
                toast.info({
                    component: Toast,
                    listeners: {
                        refresh: () => {
                            window.location.reload();
                        }
                    }
                });
            }
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        }
    });
}
// declare const self: ServiceWorkerGlobalScope & { __WB_MANIFEST: any[] };
// self.__WB_MANIFEST = self.__WB_MANIFEST || [];
window.addEventListener('online', () => {
    toast.dismiss('offline');
    showOnlineNotification();
});
window.addEventListener('offline', () => {
    toast.dismiss('online');
    showOfflineNotification();
});
